<template>
  <article class="sd-page sd-page--narrow noticia">
    <button type="button" class="sd-back" @click="volver">
      <span class="material-symbols-outlined">arrow_back</span> Volver
    </button>

    <!-- Cargando -->
    <div v-if="loading" class="noticia-loading">
      <div class="sd-skeleton" style="height: 18px; width: 30%"></div>
      <div class="sd-skeleton" style="height: 44px; width: 90%"></div>
      <div class="sd-skeleton" style="height: 320px"></div>
      <div class="sd-skeleton" style="height: 16px"></div>
      <div class="sd-skeleton" style="height: 16px; width: 80%"></div>
    </div>

    <!-- No encontrada -->
    <div v-else-if="!encontrada" class="sd-empty">
      <span class="material-symbols-outlined">search_off</span>
      <p>No hemos encontrado esta noticia.</p>
      <router-link :to="{ name: esCaritas ? 'CaritasParroquialNoticias' : 'vistaNoticias' }" class="sd-btn">
        Ver todas las noticias
      </router-link>
    </div>

    <template v-else>
      <header class="noticia-head">
        <p class="noticia-meta">
          <span v-if="esCaritas" class="noticia-tag">Cáritas</span>
          <time v-if="fechaTexto" :datetime="fechaPublicacion">{{ fechaTexto }}</time>
        </p>
        <h1 class="sd-title noticia-title">{{ title }}</h1>
        <p v-if="resumenNoticia" class="noticia-lead">{{ resumenNoticia }}</p>
      </header>

      <div class="sd-prose noticia-body" v-html="newBody"></div>

      <!-- Fotos de la noticia -->
      <section v-if="imagenesNoticia.length" class="noticia-section">
        <h2 class="noticia-section-title">
          <span class="material-symbols-outlined">photo_library</span> Fotos
        </h2>
        <grid-fotos :listaImagenes="imagenesNoticia" />
      </section>

      <!-- Acciones -->
      <footer class="noticia-actions">
        <button v-if="idGallery && idGallery != 0" type="button" class="sd-btn" @click="goGallery">
          <span class="material-symbols-outlined">collections</span>
          Ver galería completa
        </button>

        <botones-compartir
          class="noticia-share"
          etiqueta="Compartir"
          :titulo="title"
          :texto="resumenNoticia"
          :ruta="'/noticia?id=' + $route.query.id"
          tipo="noticia"
          :id="String($route.query.id)"
        />
      </footer>
    </template>
  </article>
</template>

<script>
import axios from "@/directives/axios.js";
import GridFotos from "@/components/galeria/GridFotos.vue";
import BotonesCompartir from "@/components/compartir/BotonesCompartir.vue";
import { track } from "@/directives/analitica.js";

const MESES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

export default {
  name: "vistaNoticia",
  components: {
    GridFotos,
    BotonesCompartir,
  },
  metaInfo() {
    return {
      link: [
        {
          rel: "canonical",
          href: `${this.$root.constantes.sitio_web}${this.$route.fullPath}`,
        },
      ],
      title: `${this.$root.constantes.nombre_sitio} - ${this.title}`,
      meta: [
        {
          name: "description",
          content: `${this.resumenNoticia}`,
        },
      ],
    };
  },
  data() {
    return {
      loading: true,
      encontrada: false,
      newBody: "",
      title: this.$route.query.title || "",
      idGallery: undefined,
      resumenNoticia: "",
      imagePortada: "",
      fechaPublicacion: "",
      imagenesNoticia: [],
    };
  },
  computed: {
    esCaritas() {
      return String(this.$route.query.id || "").includes("caritas");
    },
    fechaTexto() {
      const m = String(this.fechaPublicacion || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
      return m ? `${+m[3]} de ${MESES[+m[2] - 1]} de ${m[1]}` : "";
    },
  },
  watch: {
    "$route.query.id"(id) {
      if (id) this.getnews();
    },
  },
  mounted() {
    this.getnews();
  },
  methods: {
    async getnews() {
      const id = String(this.$route.query.id || "");
      this.loading = true;
      this.encontrada = false;
      if (!id) {
        this.loading = false;
        return;
      }

      const url = id.includes("caritas")
        ? "/noticiasCaritas/noticiaId?id=" + id.split("-")[1]
        : "/noticias/noticiaId?id=" + id;

      try {
        const { data } = await axios.get(url);
        const noticia = data && data.noticia;
        if (noticia) {
          this.encontrada = true;
          this.title = noticia.titulo;
          this.idGallery = noticia.idgaleria;
          this.newBody = noticia.htmlText || "";
          this.resumenNoticia = noticia.resumenNoticia || "";
          this.imagePortada = noticia.imagenPortada;
          this.fechaPublicacion = noticia.fechaPublicacion || "";
          this.imagenesNoticia = (noticia.imagenesNoticia || []).map((element) => ({
            urlImage: element.nombre_imagen,
          }));
          this.modifyMeta();
        }
      } catch (e) {
        this.encontrada = false;
      } finally {
        this.loading = false;
      }
    },
    modifyMeta() {
      const set = (prop, value) => {
        const el = document.querySelector(`head meta[property="${prop}"]`);
        if (el) el.content = value;
      };
      set("og:title", this.title);
      set("og:description", this.resumenNoticia);
      set("og:url", document.location.href);
    },
    goGallery() {
      track("abrir_album", { item_id: String(this.idGallery), item_name: this.title, origen: "noticia" });
      this.$router.push({
        name: "carrete",
        query: { id: this.idGallery, title: (this.title || "").replace(/ /g, "_") },
      });
    },
    volver() {
      if (window.history.length > 1) this.$router.go(-1);
      else this.$router.push({ name: this.esCaritas ? "CaritasParroquialNoticias" : "vistaNoticias" });
    },
  },
};
</script>

<style scoped>
.noticia-loading {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.noticia-head {
  margin-bottom: 32px;
  padding-bottom: 28px;
  border-bottom: 1px solid var(--sd-border);
}

.noticia-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 12px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--sd-gold);
}

.noticia-meta time {
  color: var(--sd-gold);
}

.noticia-tag {
  padding: 3px 10px;
  border-radius: 999px;
  background: #b91c1c;
  font-size: 0.7rem;
  font-weight: 700;
  color: #fff;
}

.noticia-title {
  font-size: clamp(1.8rem, 4.5vw, 2.8rem);
}

.noticia-lead {
  margin: 16px 0 0;
  font-size: 1.2rem;
  line-height: 1.6;
  color: var(--sd-muted);
}

.noticia-section {
  margin-top: 48px;
}

.noticia-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--sd-text);
}

.noticia-section-title .material-symbols-outlined {
  color: var(--sd-primary);
}

.noticia-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid var(--sd-border);
}

.noticia-share {
  margin-left: auto;
}

@media (max-width: 520px) {
  .noticia-share {
    margin-left: 0;
  }
}
</style>
